const GA_SCRIPT_ID = "afrimed-ga-script";

function isValidGaId(value = "") {
  const id = String(value || "").trim();
  if (!id) return false;
  if (id.startsWith("your-")) return false;
  return /^G-[A-Z0-9]+$/i.test(id) || /^UA-\d+-\d+$/i.test(id);
}

function removeScriptById(id) {
  const el = document.getElementById(id);
  if (el?.parentNode) el.parentNode.removeChild(el);
}

function clearCookiesByPrefix(prefix) {
  const names = document.cookie
    .split(";")
    .map((part) => part.split("=")[0]?.trim())
    .filter(Boolean)
    .filter((name) => name.startsWith(prefix));

  if (names.length === 0) return;

  const host = window.location.hostname;
  const baseDomain = host.split(".").slice(-2).join(".");
  const domains = Array.from(
    new Set([host, `.${host}`, baseDomain ? `.${baseDomain}` : ""])
  ).filter(Boolean);

  for (const name of names) {
    document.cookie = `${name}=; Max-Age=0; path=/`;
    for (const domain of domains) {
      document.cookie = `${name}=; Max-Age=0; path=/; domain=${domain}`;
    }
  }
}

function ensureGaLoaded(gaId) {
  if (document.getElementById(GA_SCRIPT_ID)) return;
  const script = document.createElement("script");
  script.id = GA_SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(
    gaId
  )}`;
  document.head.appendChild(script);
}

function gtag(...args) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(args);
}

function syncGoogleAnalytics(state) {
  const gaId = import.meta.env.VITE_GOOGLE_ANALYTICS_ID;
  if (!isValidGaId(gaId)) return;

  const analyticsAllowed = !!(
    state?.choices?.statistics || state?.choices?.performance
  );
  const adsAllowed = !!state?.choices?.targeting;
  const personalizationAllowed = !!(
    state?.choices?.targeting || state?.choices?.social
  );
  const functionalityAllowed = !!state?.choices?.functionality;

  window[`ga-disable-${gaId}`] = !analyticsAllowed;

  if (!analyticsAllowed) {
    removeScriptById(GA_SCRIPT_ID);
    clearCookiesByPrefix("_ga");
    return;
  }

  ensureGaLoaded(gaId);
  gtag("js", new Date());
  gtag("consent", "update", {
    analytics_storage: analyticsAllowed ? "granted" : "denied",
    ad_storage: adsAllowed ? "granted" : "denied",
    ad_user_data: adsAllowed ? "granted" : "denied",
    ad_personalization: personalizationAllowed ? "granted" : "denied",
    functionality_storage: functionalityAllowed ? "granted" : "denied",
    personalization_storage: personalizationAllowed ? "granted" : "denied",
    security_storage: "granted",
  });
  gtag("config", gaId, {
    anonymize_ip: true,
    allow_google_signals: false,
  });
}

export function applyConsentSideEffects(state) {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  syncGoogleAnalytics(state || {});
}
